import React, { useState, useEffect } from 'react';
import ThemeToggle from './ThemeToggle'; 

const LayoutHeader = ({ userName, onProfileClick, onLogout, onDeviceSelect, devices, selectedDevice, isDarkMode, toggleDarkMode, userPlan, onUpgradeClick, onMenuToggle }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [currentPlanName, setCurrentPlanName] = useState('Cargando...');

  const API_BASE_URL = 'https://holmio.net/app/api.php';

  useEffect(() => {
    const fetchPlanName = async () => {
      if (userPlan) {
        try {
          const response = await fetch(`${API_BASE_URL}/plans?id=${userPlan}`);
          const data = await response.json();
          if (data.status === 'success' && data.data.length > 0) {
            setCurrentPlanName(data.data[0].name);
          } else {
            setCurrentPlanName('Desconocido');
          }
        } catch (error) {
          console.error('Error al cargar nombre del plan:', error);
          setCurrentPlanName('Error');
        }
      }
    };
    fetchPlanName();
  }, [userPlan]);

  const handleProfileClick = () => {
    setIsDropdownOpen(false);
    onProfileClick();
  };

  const handleLogoutClick = () => {
    setIsDropdownOpen(false);
    onLogout();
  };

  const headerBgClass = isDarkMode ? 'bg-gray-900 text-white' : 'bg-blue-800 text-white';
  const dropdownBgClass = isDarkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-200 text-gray-800';
  const dropdownHoverClass = isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-blue-100';
  const selectBgClass = isDarkMode ? 'bg-gray-700 text-white border-gray-600 focus:ring-blue-500' : 'bg-blue-100 text-blue-800 border-blue-300 focus:ring-blue-600';
  const selectArrowColorClass = isDarkMode ? 'text-gray-300' : 'text-blue-800';
  const upgradeButtonClass = isDarkMode ? 'bg-green-600 text-white hover:bg-green-500' : 'bg-green-500 text-white hover:bg-green-600';
  const menuButtonFocusClass = isDarkMode ? 'focus:ring-offset-gray-900 focus:ring-gray-700' : 'focus:ring-offset-blue-800 focus:ring-blue-600';

  return (
    <header className={`flex items-center justify-between p-4 shadow-lg rounded-b-2xl transition-colors duration-300 ${headerBgClass}`}>
      <button 
        onClick={onMenuToggle} 
        className={`md:hidden p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 ${menuButtonFocusClass}`}
      >
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>

      <div className="flex items-center space-x-2">

        <span className="text-xl font-bold">Holmio IoT</span>
      </div>

      <div className="relative hidden md:block">
       
      </div>

      <div className="relative flex items-center space-x-4">
        <ThemeToggle isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
        
        <div className="flex items-center space-x-2 hidden sm:flex">
          <span className="text-sm font-medium">Plan: {currentPlanName}</span>
          <button
            onClick={onUpgradeClick}
            className={`px-3 py-1 rounded-full text-xs font-semibold transition-colors shadow-md hover:shadow-lg transform hover:-translate-y-0.5 ${upgradeButtonClass}`}
          >
            Mejorar Plan
          </button>
        </div>

        <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="flex items-center space-x-2 focus:outline-none">
          <span className="text-lg font-medium">{userName}</span>
          <svg className={`w-6 h-6 ${isDarkMode ? 'text-gray-300' : 'text-blue-200'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </button>
        {isDropdownOpen && (
          <div className={`absolute right-0 top-full mt-2 w-48 border rounded-lg shadow-lg z-10 ${dropdownBgClass}`}>
            <button onClick={handleProfileClick} className={`block w-full text-left px-4 py-2 transition-colors ${dropdownHoverClass}`}>
              Ver Cuenta
            </button>
            <button onClick={handleLogoutClick} className={`block w-full text-left px-4 py-2 text-red-600 transition-colors ${dropdownHoverClass}`}>
              Cerrar Sesión
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default LayoutHeader;

// DONE